import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { registerAdmin } from "../../features/adminAuth/adminAuthStorage";

const AdminRegisterPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!formData.email || !formData.password) {
      setError("Email and password are required.");
      return;
    }

    setSubmitting(true);
    const result = await registerAdmin({
      name: formData.name,
      email: formData.email,
      password: formData.password,
    });
    if (!result.ok) {
      setError(result.message);
      setSubmitting(false);
      return;
    }

    navigate("/admin/dashboard", { replace: true });
  };

  return (
    <main className="auth-shell">
      <section className="auth-card">
        <h1>Admin Register</h1>
        <p>Create an admin account for Verixxon operations.</p>

        <form onSubmit={handleSubmit} className="auth-form">
          <label htmlFor="name">Name</label>
          <input
            id="name"
            name="name"
            type="text"
            autoComplete="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Admin"
          />

          <label htmlFor="email">Email</label>
          <input
            id="email"
            name="email"
            type="email"
            autoComplete="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="admin@verixxon.com"
          />

          <label htmlFor="password">Password</label>
          <input
            id="password"
            name="password"
            type="password"
            autoComplete="new-password"
            value={formData.password}
            onChange={handleChange}
            placeholder="Create password"
          />

          {error ? <p className="auth-error">{error}</p> : null}

          <button type="submit" disabled={submitting}>
            {submitting ? "Creating..." : "Create admin account"}
          </button>
        </form>

        <p className="auth-switch">
          Already have admin access? <Link to="/admin/login">Sign in</Link>
        </p>
      </section>
    </main>
  );
};

export default AdminRegisterPage;
